function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 40 33",
  fill: "none"
}, props),
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.642 21.19c5.028 0 9.172-4.153 9.172-9.36s-4.144-9.36-9.172-9.36c-5.028 0-9.172 4.153-9.172 9.36s4.144 9.36 9.172 9.36zm0 2.47c1.78 0 3.468-.406 4.977-1.132C17.28 28.422 22.206 33 28.184 33c6.43 0 11.642-5.296 11.642-11.83S34.615 9.34 28.185 9.34c-1.78 0-3.468.406-4.977 1.132C22.545 4.578 17.62 0 11.642 0 5.212 0 0 5.297 0 11.83c0 6.534 5.212 11.83 11.642 11.83zM19.014 21h-.016a11.864 11.864 0 004.195-7.684 8.84 8.84 0 01.704-.423 8.974 8.974 0 014.288-1.083c5.028 0 9.172 4.153 9.172 9.36s-4.144 9.36-9.172 9.36c-5.028 0-9.172-4.153-9.172-9.36V21zm4.944-2.46l1.732-1.76 2.683 2.726 2.666-2.71 1.73 1.76-2.665 2.71 2.96 3.01-1.73 1.76-2.962-3.01-2.978 3.027-1.732-1.76 2.977-3.026-2.682-2.726zm-13.167-1.9l6.693-7.838-1.88-1.604-5 5.86-3.32-3.152-1.7 1.792 5.208 4.943z",
  fill: "#354147"
})));